<!-- Order View Container -->
<div data-testid="o2o-order-view-page" class="flex flex-col h-full">
  @if (!hideToast) {
    <p-toast data-testid="o2o-order-view-toast"></p-toast>
  }

  @if (pendingModification(); as pending) {
    <div
      class="mx-4 mt-3 rounded border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
      data-testid="o2o-order-modification-pending-banner"
    >
      {{
        'order_modification.banner.pending'
          | translate
            : {
                level: pending.requiredApprovalLevel,
                expiresAt: pending.expiresAt,
              }
      }}
    </div>
  }

  @if (loading()) {
    <div
      class="flex items-center justify-center py-12 min-h-64"
      aria-busy="true"
      aria-live="polite"
    >
      <div
        data-testid="o2o-order-view-loading"
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
      ></div>
    </div>
  } @else if (formFields.length > 0) {
    <app-order-create-layout
      data-testid="o2o-order-view-layout"
      [titleKey]="titleKey"
      [formFields]="formFields"
      [tableSections]="tableSections"
      [summarySection]="summarySection"
      [trailingSections]="trailingSections"
      [initialData]="formData"
      [headerActions]="headerActions"
      [sectionButtons]="sectionButtons"
      [hideProductSearch]="true"
      [isDisableCoupon]="true"
      [autoExpandPackageChildren]="true"
      (formAction)="onFormAction($event)"
      (tableAction)="onTableAction($event)"
      (sectionAction)="onSectionAction($event)"
    ></app-order-create-layout>
  } @else {
    <div class="flex items-center justify-center h-64">
      <div class="text-center">
        <p class="text-gray-600 mb-4">{{ 'o2o.view.no_data' | translate }}</p>
        <button
          data-testid="o2o-order-view-back-btn"
          type="button"
          (click)="router.navigate([backRoute])"
          class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          {{ 'common.actions.go_back' | translate }}
        </button>
      </div>
    </div>
  }
</div>
